import React from 'react';
import { getStatusColor } from '../utils/helpers';

const StatusBadge = ({ status, className = '' }) => {
  const colorClass = getStatusColor(status);
  const labels = {
    active: 'Activo',
    completed: 'Completado',
    archived: 'Archivado',
    planning: 'Planificación',
    'at-risk': 'En riesgo',
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass} ${className}`}
    >
      {labels[status] || status}
    </span>
  );
};

export default StatusBadge;
